import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { ApplicationInsights, ICustomProperties } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs';
import { EventMessage, EventType } from '@azure/msal-browser';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()

export class ApplicationInsightsService {
    appInsights: ApplicationInsights;
    name: string | undefined = '';
    email: string | undefined = '';

    constructor(private authService: MsalService, private broadcastService: MsalBroadcastService, private router: Router) {
        const appInsightsKey = environment.APPLICATION_INSIGHTS_INSTRUMENTATION_KEY;
        var angularPlugin = new AngularPlugin();

        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: appInsightsKey,
                enableAutoRouteTracking: true, // optional: auto-log all route changes
                extensions: [angularPlugin],
                extensionConfig: {
                    [angularPlugin.identifier]: { router: this.router }
                }
            },
        });
        if(!!this.authService.instance.getActiveAccount()){
            const userInfo = this.authService.instance.getActiveAccount();

            if (userInfo == null)
            return;

            this.name = (userInfo.name?.trim() ?? "");
            this.email = (userInfo.username.trim() ?? "");

            this.appInsights.clearAuthenticatedUserContext();
            this.appInsights.setAuthenticatedUserContext(this.email, this.name, true);
            this.appInsights.addTelemetryInitializer((envelope) => {
                envelope.tags = envelope.tags || [];
                envelope.tags['ai.user.accountId'] = this.email;
                envelope.tags['ai.user.id'] = this.name;
            });
        }

        this.broadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE))
            .subscribe(() => {
                this.appInsights.clearAuthenticatedUserContext();
            }
        );

        this.appInsights.loadAppInsights();        
        this.appInsights.trackPageView();
    }

    // helper methods to track a variety of events and metric
    public logPageView(name?: string, url?: string) {
        this.appInsights.trackPageView({
            name: name,
            uri: url,
        });
    }

    public logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights.trackEvent({ name: name }, properties);
    }

    public logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights.trackMetric({ name: name, average: average }, properties);
    }

    public logException(exception: Error, severityLevel?: number) {
        this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    }

    public logTrace(message: string, properties?: { [key: string]: any }) {
        this.appInsights.trackTrace({ message: message }, properties);
    }
}